<div class="bg {{activeindex!==-1 ? 'active':''}}"></div>
<header class="header">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="header_top" *ngIf="top_menu">
                    <ul>
                        <li *ngFor="let menu of top_menu.childs"><a href="{{menu.url}}" (click)="changeLang($event,menu.title,menu.url)">{{menu.title}}</a></li>
                    </ul>
                </div>
                <div class="header_bottom">
                    <div class="navigation-toggle"
                        (click)="showMenu = !showMenu; activeChildIndex=-1; activeindex = -1; bodyclass();">
                        <span [ngClass]="showMenu ? 'active':'' "></span>
                    </div>
                    <div class="logo">
                        <a href="{{lang === 'tr' ? '/' : '/en'}}" (click)="logoClick($event)">
                            <img src="assets/images/svg/logo.svg" alt="logo" width="180" height="60" style="width: 180px; height: 60px;">
                        </a>
                    </div>
                    <ul class="search-and-branch {{searchactive?'search-active':''}}">
                        <!--input focus olunca search-active class'ı eklenmeli <ul class="search-and-branch search-active">-->
                        <li class="search">
                            <div>
                                <input [(ngModel)]="searchkey" type="text" name="search" (focus)="searchactive=true"
                                    (keyup.enter)="goSearch()"
                                    [placeholder]="translator.translate('common',lang, 'search_placeholder')">
                                <ul class="search_action">
                                    <li><button (click)="goSearch()"><img src="assets/images/icons/search.svg"
                                                alt="" width="20" height="20" style="width: 20px; height: 20px;"></button></li>
                                    <li><button (click)="searchactive=false"><img src="assets/images/icons/close.svg"
                                                alt="" width="20" height="20" style="width: 20px; height: 20px;"></button></li>
                                </ul>
                            </div>
                        </li>
                        <li class="branch">
                            <a href="#" (click)="showOnlineBanking($event)"
                                class="button-contained branch-button {{ mobilinternetsube ? 'active':''}}" style="padding:10px;">
                                {{translator.translate('common',lang, 'online_banking')}}
                            </a>
                            <div class="branch-login">
                                <ul>
                                    <li><a href="javascript:;" (click)="goLink($event,translator.translate('common',lang, 'personal'),'https://online.aktifbank.com.tr/default.aspx','https://online.aktifbank.com.tr/default.aspx?lang=en-US')"
                                            class="button-contained-white"> {{translator.translate('common',lang,
                                            'personal')}}</a></li>
                                    <li><a href="javascript:;" (click)="goLink($event,translator.translate('common',lang, 'bussiness'),'https://kurumsal.aktifbank.com.tr/default.aspx?lang=tr-TR','https://kurumsal.aktifbank.com.tr/default.aspx?lang=en-US')"
                                            class="button-contained-white"> {{translator.translate('common',lang,
                                            'bussiness')}}</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="header_nav {{ showMenu ? 'active':''}}">
                    <!--Mobil search-->
                    <ul class="search-and-branch">
                        <li class="search">
                            <div>
                                <input type="text" [(ngModel)]="searchkey" type="text" name="search"
                                    (focus)="searchactive=true" (keyup.enter)="goSearch()" name="search"
                                    placeholder="{{lang === 'tr' ? 'Ara': 'Search'}}">
                                <ul class="search_action">
                                    <li><button (click)="goSearch()"><img src="assets/images/icons/search.svg"
                                                alt="" width="20" height="20" style="width: 20px; height: 20px;"></button></li>
                                    <li><button (click)="searchactive=false"><img src="assets/images/icons/close.svg"
                                                alt="" width="20" height="20" style="width: 20px; height: 20px;"></button></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <!--Mobil search-->
                    <ul *ngIf="main_menu" (mouseleave)="activeindex=-1">
                        <li *ngFor="let menu of getSubMenus(main_menu); let i=index">
                            <a [attr.href]="isDesktopDevice() ? (hasValidUrl(menu) ? menu.url : null) : menu.url" 
                               [class.no-link]="isDesktopDevice() && !hasValidUrl(menu)"
                               (mouseover)="!searchactive && activeindex=i;" 
                               (click)="hasValidUrl(menu) && isDesktopDevice() ? menuClick($event, menu.title, menu.url, -1) : $event.preventDefault()">{{menu.title}}</a>
                            <div class="header_nav__menu {{activeindex===i ? 'active':''}}">
                                <div class="container">
                                    <div class="row {{menu.menuclass}}">
                                        <div class="mobile-previous" *ngIf="hasChild(menu)">
                                            <a href="javascript:;"
                                                (click)="activeindex = -1; activeChildIndex = -1">{{menu.title}}</a>
                                        </div>
                                        <div class="col-lg-3" *ngIf="!hasChild(menu)">
                                            <div class="header_nav__menu__wrapper">
                                                <div
                                                    class="header_nav__menu__wrapper_last {{ activeindex===i ? 'active':''}}">
                                                    <div class="mobile-previous">
                                                        <a href="javascript:;"
                                                            (click)="activeindex = -1; activeChildIndex = -1">{{menu.title}}</a>
                                                    </div>
                                                    <ul>
                                                        <li *ngFor="let smenu of getSubMenus(menu); let j = index">
                                                            <a [attr.href]="isDesktopDevice() ? (hasValidUrl(smenu) ? smenu.url : null) : smenu.url" 
                                                               [class.no-link]="isDesktopDevice() && !hasValidUrl(smenu)"
                                                               (click)="hasValidUrl(smenu) ? menuClick($event, smenu.title, smenu.url, j) : $event.preventDefault()">{{smenu.title}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="hasChild(menu)">
                                            <div [ngClass]="getMenuRowClass(smenu)" 
                                                *ngFor="let smenu of getSubMenus(menu); let j=index">
                                                <div [ngClass]="getMenuSubClass(smenu)" class="submenu-wrapper">
                                                    <a *ngIf="getMenuDirectClass(smenu) === 'direct-link'" 
                                                       [attr.href]="isDesktopDevice() ? (hasValidUrl(smenu) ? smenu.url : null) : smenu.url" 
                                                       [class.no-link]="isDesktopDevice() && !hasValidUrl(smenu)"
                                                       [ngClass]="getMenuDirectClass(smenu)"
                                                       (click)="hasValidUrl(smenu) ? menuClick($event, smenu.title, smenu.url, j) : $event.preventDefault()">{{smenu.title}}</a>
                                                    <a *ngIf="getMenuDirectClass(smenu) === 'link-none'" 
                                                       [attr.href]="isDesktopDevice() ? (hasValidUrl(smenu) ? smenu.url : null) : smenu.url" 
                                                       [class.no-link]="isDesktopDevice() && !hasValidUrl(smenu)"
                                                       [ngClass]="getMenuDirectClass(smenu)"
                                                       (mouseover)="toggleSubMenu($event, smenu, j)" 
                                                       (click)="hasValidUrl(smenu) && isDesktopDevice() ? menuClick($event, smenu.title, smenu.url, j) : $event.preventDefault()">
                                                        {{smenu.title}}
                                                      </a>
                                                         <!--a href tıklandiginde active <div class="header_nav__menu__wrapper_last active"> class eklenmeli-->
                                                  
                                                    <div class="header_nav__menu__wrapper_last {{activeChildIndex===j ? 'active':''}}" *ngIf="smenu.childs && smenu.childs.length > 0">
                                                        <div class="mobile-previous">
                                                            <a [attr.href]="isDesktopDevice() ? (hasValidUrl(smenu) ? smenu.url : null) : smenu.url" 
                                                               [class.no-link]="isDesktopDevice() && !hasValidUrl(smenu)"
                                                               (mouseover)="toggleSubMenu($event, smenu, j)" 
                                                               (click)="hasValidUrl(smenu) && isDesktopDevice() ? menuClick($event, smenu.title, smenu.url, j) : $event.preventDefault()">{{smenu.title}}</a>
                                                            </div>
                                                        <ul>
                                                      <li *ngFor="let ssmenu of smenu.childs">
                                                        <!-- Child Menu var mı ? Kontrol-->
                                                        <a [attr.href]="isDesktopDevice() ? (hasValidUrl(ssmenu) ? ssmenu.url : null) : ssmenu.url" 
                                                           [class.no-link]="isDesktopDevice() && !hasValidUrl(ssmenu)"
                                                           (click)="hasValidUrl(ssmenu) ? menuClick($event, ssmenu.title, ssmenu.url, -1) : $event.preventDefault()">{{ssmenu.title}}</a>
                                                      </li>
                                                       </ul>
                                                              
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div class="col-lg-3" *ngIf="menu?.card?.data?.item_image">
                                            <div class="header_nav__menu__banner">
                                                <a href="{{menu.card.data.item_link}}">
                                                    <figure><img loading="lazy" src="{{menu.card.data.item_image}}" alt="" width="300" height="200" style="width: 100%; height: auto; max-width: 300px;"></figure>
                                                    <p class="title" [innerHTML]="menu.card.data.item_title"></p>
                                                    <div [innerHTML]="menu.card.data.item_text">
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <ng-container *ngIf="main_menu">
                    <ng-container *ngIf="getBottomMenu(main_menu) as bottomMenu">
                        <div class="header_nav__menu_speedMenu mobile-speed-menu {{ showMenu ? 'active':''}}" *ngIf="bottomMenu.length > 0 && bottomMenu[0]?.childs">
                            <ul>
                                <li *ngFor="let smenu of bottomMenu[0].childs">
                            <a [attr.href]="isDesktopDevice() ? (hasValidUrl(smenu) ? smenu.url : null) : smenu.url" 
                               [class.no-link]="isDesktopDevice() && !hasValidUrl(smenu)"
                               (click)="hasValidUrl(smenu) ? speedMenuClick($event, smenu.title, smenu.url) : $event.preventDefault()">
                                <img src="{{smenu.image}}" 
                                     [alt]="smenu.title"
                                     loading="lazy"
                                     decoding="async"
                                     width="40" 
                                     height="40" 
                                     style="width: 40px; height: 40px;">
                                {{smenu.title}}
                            </a>
                        </li>
                            </ul>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</header>
<div class="mobile-branch-login {{ mobilinternetsube ? 'active':''}}">
    <p>{{translator.translate('common',lang, 'online_banking')}}</p>
    <ul>
        <li><a href="{{
            lang === 'tr' ? 
            'https://online.aktifbank.com.tr/default.aspx' : 
            'https://online.aktifbank.com.tr/default.aspx?lang=en-US'}}" 
            class="button-contained-white"
            (click)="goLink($event, translator.translate('common',lang, 'personal'), 'https://online.aktifbank.com.tr/default.aspx', 'https://online.aktifbank.com.tr/default.aspx?lang=en-US')">
                {{translator.translate('common',lang, 'personal')}}</a></li>
        <li><a href="{{
            lang === 'tr' ? 
            'https://kurumsal.aktifbank.com.tr/default.aspx?lang=tr-TR' :
            'https://kurumsal.aktifbank.com.tr/default.aspx?lang=en-US'
        }}" class="button-contained-white"
        (click)="goLink($event, translator.translate('common',lang, 'bussiness'), 'https://kurumsal.aktifbank.com.tr/default.aspx?lang=tr-TR', 'https://kurumsal.aktifbank.com.tr/default.aspx?lang=en-US')">
                {{translator.translate('common',lang, 'bussiness')}}</a></li>
    </ul>
</div>